import React from 'react'

import LoginForm from '../../../components/pages/Login/Form'

const Login = () => {
  return (
    <div className="flex-1 flex justify-center items-center">
      <LoginForm />
    </div>
  )
}

export default Login
